import { Base, Component, Inject } from '@/vue-property-decorator'
import { GameCardCommonProps } from '../../common.type'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import Modal from '@/controller/Modal'
import style from './style.module.scss'

/** 游戏维护层 */
@Component<MaskMaintain>({
  name: 'MaskMaintain'
})
export default class MaskMaintain extends Base {
  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<GameCardCommonProps>

  /** 维护图标的地址
   * 维护图标存放文件夹是固定的,有10多种可选的配置,以名字的最后一位数字进行区分,按照后端返回的数字拼接路径
   */
  private get iconUrl() {
    const { homeLayoutInfos } = useMainStore()
    const iconType = homeLayoutInfos?.commonConfig?.gameMaintenanceType || '1'
    return `/lobby_asset/common/common/home/img_whz_style_${iconType}.png`
  }

  render() {
    const { t } = useI18n()
    const { inCardShape, isAtSwiper, atSwiperDomId } = this.cardProps
    return (
      <div
        class={{
          [style['mask-maintain']]: true,
          [style[`type-${inCardShape}-default`]]: true
        }}
        onClick={(event) => {
          event.stopPropagation()
          Modal.message({
            type: 'warning',
            content: t('lobby.game.gameMaintainText')
          })
        }}
      >
        <my-img
          options={{
            type: 'div',
            lazy: !isAtSwiper,
            immediate: isAtSwiper
          }}
          syncGroupsSrc={isAtSwiper}
          syncGroupsWrapId={atSwiperDomId}
          // 原 maintain-circle 这个类样式,还是有很多地方在配置它的,后续都行一下调整
          class={[style['maintain-icon'], 'maintain-icon']}
          src={this.iconUrl}
        />
      </div>
    )
  }
}
